import script from "./AddEditInvoice.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddEditInvoice.vue?vue&type=script&setup=true&lang=ts"

import "./AddEditInvoice.vue?vue&type=style&index=0&id=5bfa6d04&lang=sass"

const __exports__ = script;

export default __exports__